const appColors = Object.freeze({
    BLUE_DARK: "#171580",
    BLUE_LIGHT: "#e1e0ff",
    BLUE_SEC: "#0077b6",
    BLACK: "#02010a",
    WHITE: "#ffffff",
    GREY_DARK: "#ced4da",
    GREY_LIGHT: "#fafaff",
    INFO_BLUE: "#00a6fb",
    RED: "#ff1654",
    GREEN: "#7bf1a8",
    YELLOW: "#ffd100",
    YELLOW_LIGHT: "#fff1b2",
})

export const palette = {
    primary: {
        main: appColors.BLUE_DARK,
        light: appColors.BLUE_LIGHT,
        contrastText: appColors.WHITE,
    },
    secondary: {
        main: appColors.BLUE_SEC,
        contrastText: appColors.WHITE,
    },
    info: {
        main: appColors.INFO_BLUE,
        contrastText: appColors.WHITE,
    },
    error: {
        main: appColors.RED,
        contrastText: appColors.WHITE,
    },
    success: {
        main: appColors.GREEN,
        contrastText: appColors.WHITE,
    },
    warning: {
        main: appColors.YELLOW,
        light: appColors.YELLOW_LIGHT,
        contrastText: appColors.WHITE,
    },
    text: {
        primary: appColors.BLACK,
        secondary: appColors.BLUE_DARK,
        disabled: appColors.GREY_DARK,
    },
    background: {
        default: appColors.GREY_DARK,
        paper: appColors.GREY_LIGHT,
    },
    common: {
        black: appColors.BLACK,
        white: appColors.WHITE,
    }
}
